import React, { useEffect, useState } from "react";
import { format } from "date-fns";

import { Box, Typography } from "@mui/material";

import { useTheme } from "@mui/material/styles";

import useLocalization from "../../hooks/useLocalization";

import CallDocketModal from "../modals/CallDocketModal";

const Call = ({ call, showDate, showProject, onRefresh }) => {
  const theme = useTheme();

  const { callStatus } = useLocalization();

  const [openModal, setOpenModal] = useState(false);

  // Debug unknown call statuses
  useEffect(() => {
    if (call.callStatus && !callStatus[call.callStatus]) {
      console.warn(
        `[Call.jsx] Unknown call status: "${call.callStatus}" for call ID: ${call.id || call._id}`,
        "Available statuses:",
        Object.keys(callStatus),
      );
    }
  }, [call.callStatus, call.id, call._id, callStatus]);

  const handleCallClick = () => {
    setOpenModal(true);
  };

  return (
    <>
      <Box
        sx={{
          boxShadow: theme.shadows[4],
          padding: "4px",
          borderRadius: "4px",
          cursor: "pointer",
        }}
        onClick={handleCallClick}
      >
        {showProject && (
          <Typography sx={{ fontSize: "10px", fontWeight: "bold" }}>
            {call?.project?.name || "Unknown Project"}
          </Typography>
        )}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ fontSize: "8px", fontWeight: "bold" }}>
            {call?.location?.name || "Unknown Location"}
          </Typography>
          <Typography sx={{ fontSize: "8px" }}>
            #{call?.location?.locationNumber || "-"}
          </Typography>
        </Box>
        <Typography sx={{ fontSize: "6px" }}>
          {call?.location?.address?.streetAddress || ""}
        </Typography>
        <Typography sx={{ fontSize: "6px" }}>
          {`${call?.location?.address?.city || ""}, ${
            call?.location?.address?.province || ""
          }, ${call?.location?.address?.postal || ""}`}
        </Typography>
        <Typography sx={{ fontSize: "8px", fontWeight: "bold" }}>
          {call.repName ? call.repName : "No Rep Assigned"}
        </Typography>
        {call.callStatus &&
          callStatus[call.callStatus] &&
          (showDate ? (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography sx={{ fontSize: "8px" }}>
                {(() => {
                  const dateVal = call?.scheduleDate || call?.yyyymmdd;
                  try {
                    const d =
                      typeof dateVal === "string" ? new Date(dateVal) : dateVal;
                    return format(d, "EEE MMM dd");
                  } catch (e) {
                    return call?.yyyymmdd || "";
                  }
                })()}
              </Typography>
              <Box
                sx={{
                  backgroundColor: callStatus[call.callStatus].color,
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                }}
              ></Box>
            </Box>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box>
                <Typography sx={{ fontSize: "8px" }}>
                  {call?.territory?.name || "Unassigned"}
                </Typography>
              </Box>
              <Box
                sx={{
                  backgroundColor: callStatus[call.callStatus].color,
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                }}
              ></Box>
            </Box>
          ))}
        {call.repNotes && (
          <Typography sx={{ fontSize: "6px" }}>
            Rep has provide notes.
          </Typography>
        )}
      </Box>

      {openModal && (
        <CallDocketModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          call={call}
          onRefresh={onRefresh}
        />
      )}
    </>
  );
};

export default Call;
